import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares ';
import _ from 'lodash';
import { useContext, useEffect } from 'react';
import { Icon, Label } from 'semantic-ui-react';
import UpDownLabel from '../../../global/components/forms/elements/UpDownLabel';
import Wrapper, { wrapperTypes } from '../../../global/wrappers/Wrapper';
import WrapperVertCols from '../../../global/wrappers/WrapperVertCols';
import { useCreateSportsSeason } from '../useHelpers/useCreateSeasonal';
import { CreateSportsSeasonContext } from './CreateSeason';
import { useSportsFilters } from '../useHelpers/useSportsFilters';

const CreateSportSeasonTeams = () => {

  const { getCreateSportsSeason, ammendSeasonalItem } = useCreateSportsSeason()
  const { getLevelTeams, getHomeAways, getSectionDates } = useSportsFilters()

  const { sportsData_info, sportsSeason_selected } = getCreateSportsSeason()
  const { districtTeams } = sportsData_info ?? {}
  const { seasonals } = sportsSeason_selected ?? {}
  const { sectionCounts, teams: sportSeasonTeams } = seasonals ?? {}

  // createSportsSeaonContext
  const createSportsSeaonContext = useContext(CreateSportsSeasonContext);
  const { createSportsSeason_handlers } = createSportsSeaonContext ?? {}

  const handle_addTeams = () => setInit()

  const handleClear = (type) => {
    switch (type) {
      case 'districtTeams':
        const _districtTeams = _.cloneDeep(districtTeams)
        _.forEach(_districtTeams, (districtTeam) => {
          districtTeam._selected = false
        })
        createSportsSeason_handlers.handleAmmend_districtTeams(_districtTeams)
        break;
      case 'teams':
        const _sportSeasonTeams = _.cloneDeep(sportSeasonTeams)
        _.forEach(_sportSeasonTeams, (team_sport) => {
          team_sport._selected = false
        })
        ammendSeasonalItem({ key: 'teams', data: _sportSeasonTeams })
        break;
    }
  }

  const handleSelect_team = (type, team) => {
    const _districtTeams = _.cloneDeep(districtTeams)
    const _sportSeasonTeams = _.cloneDeep(sportSeasonTeams)
    switch (type) {
      case 'districtTeams':
        if (!_sportSeasonTeams[team._itemKey]) {
          _sportSeasonTeams[team._itemKey] = team
          _sportSeasonTeams[team._itemKey]._new = true
          _districtTeams[team._itemKey]._selected = !_districtTeams[team._itemKey]._selected
        }
        createSportsSeason_handlers.handleAmmend_districtTeams(_districtTeams)
        ammendSeasonalItem({ key: 'teams', data: _sportSeasonTeams })
        break;
      case 'teams':
        _districtTeams[team._itemKey]._selected = !_districtTeams[team._itemKey]._selected
        createSportsSeason_handlers.handleAmmend_districtTeams(_districtTeams)
        // const teams_updated = _.omit(_sportSeasonTeams, teamKey);
        // const {levelTeams} = getLevelTeams({ teams: teams_updated })
        // console.log('zzz', zzz)
        const _sportSeason_teams = removeTeamAndReindex(_sportSeasonTeams, team._itemKey)
        console.log('_sportSeason_teams', _sportSeason_teams)
        // delete _sportSeasonTeams[team._itemKey]
        // const zzz = getLevelTeams({ teams: _sportSeasonTeams })
        // console.log('_sportSeasonTeams', _sportSeasonTeams)
        // console.log('zzz', zzz)
        ammendSeasonalItem({ key: 'teams', data: _sportSeason_teams })
        break;
    }
  }

  const removeTeamAndReindex = (teams, teamKey) => {
    // 1. Remove team
    const updated = _.omit(teams, teamKey);

    // 2. Convert to entries for easier reconstruction later
    const entries = Object.entries(updated);

    // 3. Group by level + section
    const grouped = _.groupBy(entries, ([, team]) => {
      return `${team.levels}__${team.sections}`;
    });

    // 4. Process each group
    const rebuiltEntries = _.flatMap(grouped, (groupEntries) => {
      // sort by position
      const sorted = _.sortBy(groupEntries, ([, team]) => team.position);

      // reindex within group
      return sorted.map(([key, team], index) => [
        key,
        { ...team, position: index }
      ]);
    });

    // 5. Back to object
    return Object.fromEntries(rebuiltEntries);
  };

  const removeTeamAndReindexCCC = (levelTeams, teamKey) => {
    // 1. Remove the team
    const updated = _.omit(teams, teamKey);

    // 2. Convert to array + sort by position
    const sortedTeams = _.sortBy(_.values(updated), 'position');

    // 3. Reassign positions
    const reindexed = sortedTeams.map((team, index) => ({
      ...team,
      position: index
    }));

    // 4. Convert back to object (preserve keys)
    return _.mapValues(updated, (team) => {
      const newTeam = _.find(reindexed, t => t.id === team.id);
      return newTeam || team;
    });
  };

  const handleUpDown_sectionCount = (propKey, value) => {
    const _levelCounts = _.cloneDeep(sectionCounts)
    _levelCounts[propKey] = value ? value : 0
    ammendSeasonalItem({ key: 'sectionCounts', data: _levelCounts })
  }

  const icon_l = (type) => <Icon name='delete' color={'red'} style={{ float: 'right', marginLeft: '1em' }} onClick={() => handleClear(type)}></Icon>
  const icon_r = (type) => <Icon name='arrow right' style={{ float: 'right', marginLeft: '1em' }} onClick={() => handle_addTeams(type)}></Icon>

  const header_district = (type, count) => <div style={{ display: 'grid', gridTemplateColumns: '1fr auto auto auto', alignItems: 'center' }}>
    <div>{_.startCase(type)}</div>
    {icon_l(type)}
    <Label style={{ float: 'right' }} >{count}</Label>
    {icon_r(type)}
  </div>

  const header_teams = (type, count) => <div style={{ display: 'grid', gridTemplateColumns: '1fr auto auto auto', alignItems: 'center' }}>
    <div>{_.startCase(type)}</div>
    {icon_l(type)}
    <Label style={{ float: 'right' }} >{count}</Label>
  </div>

  const hasDynamicKey = (obj, key) => {
    return _.some(obj, (value, objKey) =>
      objKey === key || (_.isPlainObject(value) && hasDynamicKey(value, key))
    );
  };

  const getParentKeysForKey = (obj, key, parentKeys = []) => {
    // Iterate through the object's keys and values
    return _.some(obj, (value, objKey) => {
      if (objKey === key) {
        // Match found, return the current path
        parentKeys.push(objKey);
        return true;
      } else if (_.isPlainObject(value)) {
        // Continue searching in nested objects
        const found = getParentKeysForKey(value, key, [...parentKeys, objKey]);
        if (found) {
          parentKeys.push(objKey);
          return true;
        }
      }
      return false;
    }) && parentKeys.reverse(); // Reverse to preserve parent-to-child order
  };

  // const menu_sectionCount = () => {
  //   const items = _.map(sectionCounts, (sl, slKey) => {
  //     return <UpDownLabel propKey={slKey} formData={sectionCounts} handleChange={handleUpDown_sectionCount} buttonSize={'tiny'} float={'left'} />
  //   })
  //   return <div>
  //     {items}
  //   </div>
  // }

  const cnt_district = (team) => {
    const { _itemKey } = team
    const inTeams = sportSeasonTeams?.[_itemKey] ? true : false
    return <Icon name={inTeams ? 'check circle' : 'arrow right'} color={inTeams ? 'green' : 'blue'} onClick={() => !inTeams && handleSelect_team('districtTeams', team)} />
  }

  const cnt_teams = (team) => <Icon name='check circle' color='green' onClick={() => handleSelect_team('teams', team)} />

  const content_districtTeams = () => {
    const _districtTeams = _.sortBy(districtTeams, 'name')
    return <Wrapper
      header={header_district('districtTeams', _.size(districtTeams))}
      content={<ItemMenuSquares menuItems={_districtTeams} iconItem={'users'} imsType={_imsTypes.inline} fn_altContent={cnt_district} />}
      wrapperType={wrapperTypes.padded}
    />
  }

  const content_teams = () => {
    let _sportSeasonTeams = _.sortBy(sportSeasonTeams, 'name')
    return <Wrapper
      header={header_teams('seasonTeams', _.size(_sportSeasonTeams))}
      content={<ItemMenuSquares menuItems={_sportSeasonTeams} iconItem={'users'} imsType={_imsTypes.inline} fn_altContent={cnt_teams} />}
      wrapperType={wrapperTypes.padded}
    />
  }

  // const content_sectionCount = () => <Wrapper
  //   header={'Section Count'}
  //   content={menu_sectionCount()}
  //   wrapperType={wrapperTypes.padded}
  // />

  const content_season = () => <WrapperVertCols mvc={2}>
    {districtTeams ? content_districtTeams() : <div>District Teams</div>}
    {sportSeasonTeams ? content_teams() : <div>Teams</div>}
    {/* {content_sectionCount()} */}
  </WrapperVertCols>

  const wrapper_season = () => <Wrapper
    header={'Teams'}
    content={content_season()}
    wrapperType={wrapperTypes.paddedHeader}
  />

  return wrapper_season()

}

export default CreateSportSeasonTeams